import Login from '../../pages/hjwq/bank/login';
import Index from '../../pages/hjwq/bank/index';
import Download from '../../pages/hjwq/bank/download';

const base = 'bank';

const routes = [
  {
    path: `/${base}/`,
    name: `${base}-login`,
    component: Login
  },
  {
    path: `/${base}/login*`,
    name: `${base}-login`,
    component: Login
  },
  {
    path: `/${base}/enter*`,
    name: `${base}-enter`,
    component: Index
  },
  {
    path: `/${base}/download*`,
    name: `${base}-download`,
    component: Download
  },
];

export default routes;



// WEBPACK FOOTER //
// ./src/router/hjwq/bank.js